import lightTheme from '../light/lightTheme';
import { graphic } from 'echarts';

const darkColors = {
  main: {
    primary: '#34AAD0',
    primaryGradient: 'linear-gradient(261.31deg, #006CCF -29.57%, #00509A 121.11%)',
    light: '#696969',
    secondary: '#dc88f5',
    error: '#ff3d71',
    warning: '#ffaa00',
    success: '#62d7c6',
    angularGradient:
      'conic-gradient(from -35.18deg at 50% 50%, #006CCF -154.36deg, #FF5252 24.13deg, #FFB155 118.76deg, #006CCF 205.64deg, #FF5252 384.13deg)',
    mainBackground: '#0D0D0D',
    secondaryBackground: '#1C1C1C',
    spinnerBase: '#34AAD0',
    chartPrimaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: '#34AAD0',
      },
      {
        offset: 1,
        color: 'rgba(193, 225, 255, 0)',
      },
    ]),
    chartSecondaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: '#a42218',
      },
      {
        offset: 1,
        color: 'rgba(255, 255, 255, 0)',
      },
    ]),
    chartAdditionalGradient: new graphic.LinearGradient(0, 0, 0, 1, [
      {
        offset: 0,
        color: '#306955',
      },
      {
        offset: 1,
        color: 'rgba(255, 255, 255, 0)',
      },
    ]),
  },
  text: {
    main: '#ffffff',
    light: '#9A9B9F',
    superLight: '#444',
    secondary: '#ffffff',
    dark: '#404040',
  },
  border: {
    main: '#ffffff',
  },
  dashboardMap: {
    background: 'linear-gradient(315deg, #0cbaba 0%, #380036 74%)',
    dotsColor: '#FFFFFF',
    dotsHoveredColor: '#34AAD0',
    markerBorderColor: '#34AAD0',
    controlColor: '#FFFFFF',
    controlBackgroundColor: '#34AAD0',
    controlDisabledBackgroundColor: '#b3cbe1',
  },
  charts: {
    tooltipLabel: '#6a7985',
    color1: '#34AAD0',
    color1Tint: '#34AAD0', // update
    color2: '#41a8c9',
    color2Tint: '#5eadc6', // update
    color3: '#62d7c6',
    color3Tint: '#62d7c6', // update
    color4: '#306955',
    color4Tint: '#306955', // update
    color5: '#ff3d71',
    color5Tint: '#ff3d71', // update
  },
  shadow: {
    color: 'rgba(0, 0, 0, 0.07)',
  },
  notifications: {
    success: '#EFFFF4',
    primary: '#D7EBFF',
    warning: '#FFF4E7',
    error: '#FFE2E2',
  },
};

const boxShadow = {
  main: '0 2px 8px 0 rgba(255, 255, 255, 0.07)',
  hover: '0 4px 16px 0 rgba(255, 255, 255, 0.2)',
};

export const darkTheme = {
  ...lightTheme,
  colors: darkColors,
  boxShadow,
};
